import React from "react";
import "./email.css";
import { Fade } from "react-reveal";
import { usePortfolioData } from "../../hooks/usePortfolioData";

const Email = () => {
  const { data, loading } = usePortfolioData();

  if (loading || !data) {
    return null;
  }

  const { personal } = data;

  return (
    <Fade delay={1000}>
      <div className="email-container">
        <a className="email" href={`mailto:${personal.email}`}>
          {personal.email}
        </a>
        <div className="socials-line"></div>
      </div>
    </Fade>
  );
};

export default Email;
